import React, { useState } from "react"
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers"
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core"
import LuxonUtils from "@date-io/luxon"

const ScheduleFilters = (props) => {
  const {
    festival,
    genres,
    virtualGenres,
    venues,
    view,
    setView,
    tracks,
    filters,
    setFilters,
  } = props

  const handleDateChange = (event) => {
    setFilters({
      ...filters,
      date: event ? event.toISO() : null,
    })
  }

  const handleChange = (event) => {
    setFilters({
      ...filters,
      [event.target.name]: event.target.value,
    })
  }

  return (
    <div className='schedule-filters'>
      <div className={`schedule-filters__buttons ${festival}`}>
        <button
          className={view === "daily" ? "active" : ""}
          onClick={() => setView("daily")}
        >
          In Person
        </button>
        <button
          className={view === "ondemand" ? "active" : ""}
          onClick={() => setView("ondemand")}
        >
          Virtual
        </button>
      </div>

      <div className='schedule-filters__options'>
        {view !== "ondemand" && (
          <MuiPickersUtilsProvider utils={LuxonUtils}>
            <DatePicker
              autoOk
              label='Date'
              clearable
              value={filters.date}
              onChange={handleDateChange}
            />
          </MuiPickersUtilsProvider>
        )}

        {/* <FormControl variant='outlined'>
          <InputLabel id='tracks' focused>
            Track
          </InputLabel>
          <Select
            labelId='tracks'
            value={filters.track}
            onChange={handleChange}
            label='Track'
            name='track'
          >
            <MenuItem value='all'>All</MenuItem>

            {tracks.map((track) => (
              <MenuItem
                key={track}
                value={track}
                style={{
                  display: track === 'unassigned' ? 'none' : 'block',
                }}
              >
                {track}
              </MenuItem>
            ))}
          </Select>
        </FormControl> */}

        {view !== "ondemand" && (
          <FormControl variant='outlined'>
            <InputLabel id='genre' shrink>
              Genre
            </InputLabel>
            <Select
              labelId='genre'
              value={filters.genre}
              onChange={handleChange}
              label='Genre'
              name='genre'
              displayEmpty={true}
            >
              <MenuItem value=''>All</MenuItem>
              {genres.map((genre) => (
                <MenuItem key={genre} value={genre}>
                  {genre}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        {view === "ondemand" && (
          <FormControl variant='outlined'>
            <InputLabel id='genre' shrink>
              Genre
            </InputLabel>
            <Select
              labelId='virtual-genre'
              value={filters.genre}
              onChange={handleChange}
              label='Genre'
              name='genre'
              displayEmpty={true}
            >
              <MenuItem value=''>All</MenuItem>
              {virtualGenres.map((genre) => (
                <MenuItem key={genre} value={genre}>
                  {genre}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        {view !== "ondemand" && (
          <FormControl variant='outlined'>
            <InputLabel id='venue' shrink>
              Venue
            </InputLabel>
            <Select
              labelId='venue'
              value={filters.venue}
              onChange={handleChange}
              label='Venue'
              name='venue'
              displayEmpty={true}
            >
              <MenuItem value=''>All</MenuItem>
              {venues.map((venue) => (
                <MenuItem key={venue} value={venue}>
                  {venue}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </div>
    </div>
  )
}

export default ScheduleFilters
